<template>
  <TheSidebarMenuLayout>
    <AppLinkIcon
      v-for="link in links"
      :key="link.label"
      :link-item="link"
      :show-label="!isMobile"
      :class="borderTopClass(link)"
    />
  </TheSidebarMenuLayout>
</template>

<script>
// Utitlities
import SidebarMenu from '../mixins/SidebarMenu'

export default {
  name: 'SidebarMenuTeam',

  mixins: [SidebarMenu],

  data() {
    return {
      links: [
        { label: 'Mis tajetas', to: { name: 'dashboard-team' }, icon: 'fal fa-id-card-alt' },
        {
          label: 'Todas las tarjetas',
          to: { name: 'cards-listing' },
          icon: 'fal fa-window-restore',
        },
        {
          label: 'Todos los clientes',
          to: { name: 'clients-listing' },
          icon: 'fal fa-users',
        },
        {
          label: 'Plantillas',
          to: { name: 'templates-listing' },
          icon: 'fal fa-pencil-ruler',
          border: true,
        },
      ],
    }
  },
}
</script>

<style scoped></style>
